import { render, staticRenderFns } from "./RatingDetailPCCTable.vue?vue&type=template&id=714f813c&"
import script from "./RatingDetailPCCTable.vue?vue&type=script&lang=js&"
export * from "./RatingDetailPCCTable.vue?vue&type=script&lang=js&"
import style0 from "./RatingDetailPCCTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports